const calculateNumberPercentage: (num: number, percent: number) => number = (
  num,
  percent,
) => {
  const onePercent = num / 100;
  return onePercent * percent;
};

export { calculateNumberPercentage };
